import { jsx as _jsx } from "react/jsx-runtime";
import { TileGroup } from '../TileGroup';
import { Tile } from '../../ui';
import { StyledWrapper, StyledList, StyledListItem, } from './CollectionTilesGroup.style';
export function CollectionTilesGroup({ tiles }) {
    return (_jsx(StyledWrapper, { children: _jsx(StyledList, { children: tiles.map((tile) => {
                var _a;
                return (_jsx(StyledListItem, { children: tile.tiles.length > 1 ? (_jsx(TileGroup, Object.assign({}, tile, { size: "full" }))) : (_jsx(Tile, { imageUrl: tile.tile.imageUrl, size: (_a = tile.tile.size) !== null && _a !== void 0 ? _a : 'full', variant: "full", badges: tile.badges, buttons: tile.buttons, onClick: tile.tile.onClick })) }, `tile-${tile.subTitle}-${tile.tile.imageUrl}`));
            }) }) }));
}
//# sourceMappingURL=CollectionTilesGroup.js.map